import React from 'react';
import { Link } from 'react-router-dom';
import { CalendarClock } from 'lucide-react';
import { daysUntil } from '../utils/format';
import './nextAssessmentBanner.css';

// Renders a small strip telling the user when their next assessment is.
// When the current time is past `nextAvailableAt`, the primary CTA lights up.
// `to` is the per-pillar assessment URL — caller is responsible for supplying it.
//
// No duration estimate is shown ("about N minutes") — the assessment battery
// endpoint does not serve one, and the only estimates available in this
// codebase (constants.js's ASSESSMENT_TASKS) describe a stale/inactive task
// roster, so using them would be worse than saying nothing.
export default function NextAssessmentBanner({ assessment, to }) {
  if (!assessment) return null;
  const days = daysUntil(assessment.nextAvailableAt);
  const isUnlocked = days === 0 || assessment.overdue;

  return (
    <div className={`next-assessment ${isUnlocked ? 'is-unlocked' : 'is-locked'}`}>
      <span className="next-assessment-icon">
        <CalendarClock size={18} strokeWidth={1.5} />
      </span>

      <div className="next-assessment-body">
        <p className="next-assessment-title">
          {isUnlocked
            ? 'Your next assessment is ready'
            : `Next assessment in ${days} day${days === 1 ? '' : 's'}`}
        </p>
        <p className="next-assessment-detail">
          Assessments are spaced {assessment.cadenceDays} days apart so real change can be told
          apart from practice effects.
        </p>
      </div>

      <Link to={to} className="next-assessment-cta">
        {isUnlocked ? 'Take assessment' : 'Preview assessment'}
      </Link>
    </div>
  );
}
